import { Component, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { GalleryVM } from '../gallary/gallary.service';
import { SthanDetail, SthanLocation, SthanService } from './sthan.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LAccordion } from '../charitra/charitra.service';
import { AccordionVM } from '../accordion/accordion.model';
import { DomSanitizer } from '@angular/platform-browser';
import { InitScripts } from '../app.constants';
import { MetamanagerService } from '../metamanager.service';
import { MapInfoWindow, MapMarker, GoogleMap } from '@angular/google-maps';

@Component({
  selector: 'app-sthan',
  templateUrl: './sthan.component.html',
  styleUrls: ['./sthan.component.css']
})
export class SthanComponent implements OnInit {
  SearchText($event: any) {

  }

  gallery_col1 = new BehaviorSubject<GalleryVM[]>([]);
  gallery_col2 = new BehaviorSubject<GalleryVM[]>([]);
  gallery_col3 = new BehaviorSubject<GalleryVM[]>([]);
  gallery_col4 = new BehaviorSubject<GalleryVM[]>([]);
  leelas = new BehaviorSubject<AccordionVM[]>([]);
  sthanLocation = new SthanLocation();
  sthanUrl: any;
  sthanDetail = new Observable<SthanDetail>();
  title: any;
  inProgress = new BehaviorSubject<boolean>(false);
  nextDataAvailable = new BehaviorSubject<boolean>(false);

  @ViewChild('myGoogleMap', { static: false })
  map!: GoogleMap;
  @ViewChild(MapInfoWindow, { static: false })
  info!: MapInfoWindow;

  zoom = 12;
  center: any;
  options: google.maps.MapOptions = {
    zoomControl: true,
    scrollwheel: true,
    disableDoubleClickZoom: true,
    mapTypeId: 'roadmap'
  }
  markers = [] as any;
  infoContent = ''
  once = false;
  currLat = 0;
  currLng = 0;

  constructor(private sthanService: SthanService, private router: Router, private route: ActivatedRoute,
    public sanitizer: DomSanitizer, private metaManager: MetamanagerService) {
    new InitScripts().loadScripts();

  }


  ngOnInit(): void {
    var name = this.route.snapshot.paramMap.get('name');
    this.metaManager.updateMetaTitle(name + " Sthan | Mahanubhav Panth | sarvadhnya.com",
      "Mahanubhav Panth Books - Easy access to Mahanubhav panth books, Read online, download for free",
      "Mahanubhav sthan, sthan darshan, gangatir, chakradhar swami sthan, " + name + " sthan, Mahanubhav panth, sthan leela, sthan images, sthan locaion, google map location");
    //this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.title = "Images";

    this.getSthanDetails();
    

  }

  response: SthanDetail = new SthanDetail();

  getSthanDetails() {
    var name = this.route.snapshot.paramMap.get('name');
    this.sthanService.get(name ? name : "").subscribe((response) => {
      this.response = response;
      response.gallery.forEach((image, i) => {
        if (i == 0 || i == 4 || i == 8) {
          var v = this.gallery_col1.getValue().concat(image);
          this.gallery_col1.next(v);
        }
        if (i == 1 || i == 5 || i == 9) {
          var v = this.gallery_col2.getValue().concat(image);
          this.gallery_col2.next(v);
        }
        if (i == 2 || i == 6 || i == 10) {
          var v = this.gallery_col3.getValue().concat(image);
          this.gallery_col3.next(v);
        }
        if (i == 3 || i == 7 || i == 11) {
          var v = this.gallery_col4.getValue().concat(image);
          this.gallery_col4.next(v);
        }
      });

      this.setMap();

      //this.sthanUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.google.com/maps/embed/v1/search?q=mahanubhav%20' + this.sthanLocation.name + '%20sthan&key=AIzaSyDrfJJl_LneXCdDrXluRnAm4ymj11lgwoY&zoom=12');
    });
  }

  setMap() {
    this.markers = [];
    var leelaList = this.response.leelas.map((x: LAccordion) => ({
      id: x.id,
      title: x.title,
      body: "<p><i class='bi bi-geo-alt-fill'></i> स्थान: "
        + x.sthan + ", जिल्हा: " + x.city + "</p>"
        + x.leela + "<br><br><i class='bi bi-pen-fill'></i> " + x.signiture
    } as AccordionVM));

    this.leelas.next(leelaList);
    this.response.sthanLocation.geoLocationDetails.forEach(geoData => {
      this.markers.push({
        position: {
          lat: Number(geoData.latitude),
          lng: Number(geoData.longitude),
        },
        title: geoData.marathiName + ", " + this.response.sthanLocation.marathiname,
        info: geoData.marathiName + ", " + this.response.sthanLocation.marathiname,
        options: {
          animation: google.maps.Animation.DROP
        }
      });
    });



    this.sthanLocation = this.response.sthanLocation;
  }

  currentLocationButton = false;

  eventHandler(event: any, name: string) {
    if (!this.currentLocationButton) {
      this.currentLocationButton = true;
      var centerControlDiv = document.createElement('div');
      // Create the control.
      var centerControl = this.createCenterControl();
      // Append the control to the DIV.
      centerControlDiv.appendChild(centerControl);
      this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(centerControlDiv);


      var centerControl2 = this.refreshSthanLocation();
      // Append the control to the DIV.
      centerControlDiv.appendChild(centerControl2);
      this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(centerControl2);
      
    }
    console.log(event, name);

    // Add marker on double click event
    if (name === 'mapDblclick') {
      // Create the DIV to hold the control.    
    }
    else if (name == 'tilesloaded' && !this.once) {
      if (this.markers.length > 0) {
        this.once = true;
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < this.markers.length; i++) {
          bounds.extend(this.markers[i].position);
        }
        this.map.fitBounds(bounds);
      }
    }
  }

  changeMapZoom(e: any): any {
    this.zoom = e;
  }

  openInfo(marker: MapMarker, content: string) {
    this.infoContent = content;
    this.info.open(marker)
  }

  refreshSthanLocation() {
    const controlButton = document.createElement('button');

    // Set CSS for the control.
    controlButton.style.backgroundColor = '#fff';
    controlButton.style.border = '2px solid #fff';
    controlButton.style.borderRadius = '3px';
    controlButton.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
    controlButton.style.color = 'rgb(25,25,25)';
    controlButton.style.cursor = 'pointer';
    controlButton.style.fontFamily = 'Roboto,Arial,sans-serif';
    controlButton.style.fontSize = '16px';
    controlButton.style.lineHeight = '38px';
    controlButton.style.margin = '8px 0 22px';
    controlButton.style.padding = '0 5px';
    controlButton.style.textAlign = 'center';

    controlButton.textContent = 'Sthan Location';
    controlButton.title = 'Click to recenter the map';
    controlButton.type = 'button';

    // Setup the click event listeners: simply set the map to Chicago.
    controlButton.addEventListener('click', () => {
      //this.setMap();
      if (this.markers.length > 0) {
        this.once = true;
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < this.markers.length; i++) {
          bounds.extend(this.markers[i].position);
        }
        this.map.fitBounds(bounds);
      }
    });

    return controlButton;
  }

  createCenterControl() {
    const controlButton = document.createElement('button');

    // Set CSS for the control.
    controlButton.style.backgroundColor = '#fff';
    controlButton.style.border = '2px solid #fff';
    controlButton.style.borderRadius = '3px';
    controlButton.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
    controlButton.style.color = 'rgb(25,25,25)';
    controlButton.style.cursor = 'pointer';
    controlButton.style.fontFamily = 'Roboto,Arial,sans-serif';
    controlButton.style.fontSize = '16px';
    controlButton.style.lineHeight = '38px';
    controlButton.style.margin = '8px 5px 22px 0';
    controlButton.style.padding = '0 5px';
    controlButton.style.textAlign = 'center';

    controlButton.textContent = 'My Location';
    controlButton.title = 'Click to recenter the map';
    controlButton.type = 'button';

    // Setup the click event listeners: simply set the map to Chicago.
    controlButton.addEventListener('click', () => {
      //this.markers = this.markers.filter(x =>x.title != "Your location");
      if(this.currentLocationLoaded)
        this.markers.pop();

      this.currentLocationLoaded = true;
      if (navigator.geolocation) {
        this.getPosition().then(pos => {
          this.currLat = pos.lat;
          this.currLng = pos.lng;
        });
        // navigator.geolocation.getCurrentPosition(position => {
        //   this.currLat = position.coords.latitude;
        //   this.currLng = position.coords.longitude;
        // });
        this.markers.push({
          position: {
            lat: this.currLat,
            lng: this.currLng,
          },
          title: "Your location",
          info: "Your location",
          options: {
            animation: google.maps.Animation.BOUNCE
          }
        });
        this.center = { lat: this.currLat, lng: this.currLng };
      }
      else {
        alert("Geolocation is not supported by this browser.");
      }
    });

    return controlButton;
  }

  currentLocationLoaded = false;

  getPosition(): Promise<any> {
    return new Promise((resolve, reject) => {

      navigator.geolocation.getCurrentPosition(resp => {

        resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
      },
        err => {
          reject(err);
        });
    });

  }


}
